<template>
  <div ref="checkout-shipping-method">
    <h4>Shipping Method</h4>
    <v-alert outline color="info" icon="info" :value="true">
      Business Days are the carrier's estimated time in transit to deliver your order after it ships.<br/>
      Select a USPS Shipping Method for PO Box deliveries.
    </v-alert>

    <v-radio-group
      v-if="shippingMethods"
      v-model="cart.shipping_method"
      :change="changeShippingRate()"
      :mandatory="true"
      :rules="requiredRules"
    >
      <template v-for='method in shippingMethods'>
        <v-layout row v-if="showTitle(method.service)">
          <v-flex xs12>
            <h4 class="right">Shipping &amp; Processing</h4>
            <h4>{{method.service}}</h4>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs6>
            <v-radio :label="method.name" :value="method.code"></v-radio>
          </v-flex>
          <v-flex xs6 right-align>
            {{rateOrFree(method.rate)}}
          </v-flex>
        </v-layout>
      </template>
    </v-radio-group>
    <div v-else class="loading center-align pt-5 pb-5">
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular><br>
      Loading Shipping Methods...
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      shippingMethods: [Array, Boolean],
      requiredRules: [
        v => !!v || 'Cannot be blank'
      ]
    },

    computed: {
      cart: {
        get () {
          return this.$store.state.cart
        },
        set (value) {
          this.$store.commit('saveCart', value)
        }
      }
    },

    methods: {
      changeShippingRate () {
        for (var i = 0; i < this.shippingMethods.length; i++) {
          if (this.shippingMethods[i].code === this.cart.shipping_method) {
            this.cart.total_shipping = this.shippingMethods[i].rate
          }
        }
      },

      rateOrFree (rate) {
        return rate === 0 ? 'FREE' : this.$options.filters.currency(rate)
      },

      showTitle (service) {
        if (service === window.lastService) return false
        window.lastService = service
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// shipping-method.vue?4a56328e